interface NewsFilterProps {
  category: string;
  onCategoryChange: (value: string) => void;
  range: string;
  onRangeChange: (value: string) => void;
  onReset: () => void;
  resultCount: number;
}

export const categoryOptions = ["全部", "官方公告", "活动报道", "媒体采访"];
export const rangeOptions = ["全部", "近一年", "近两年", "更早"];

function OptionButton({
  active,
  label,
  onClick,
}: {
  active: boolean;
  label: string;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`px-3 py-1.5 rounded-md text-sm transition-colors cursor-pointer whitespace-nowrap ${
        active
          ? "bg-primary-500 text-background-50 font-medium"
          : "bg-background-100 text-foreground-600 hover:bg-background-200"
      }`}
    >
      {label}
    </button>
  );
}

export default function NewsFilter({
  category,
  onCategoryChange,
  range,
  onRangeChange,
  onReset,
  resultCount,
}: NewsFilterProps) {
  return (
    <div className="flex flex-col gap-6">
      <div className="flex items-center justify-between">
        <span className="text-sm text-foreground-500">
          共 <strong className="text-primary-600">{resultCount}</strong> 条动态
        </span>
        <button
          type="button"
          onClick={onReset}
          className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer flex items-center gap-1"
        >
          <i className="ri-refresh-line"></i>
          重置
        </button>
      </div>

      <div>
        <h3 className="text-sm font-semibold text-foreground-950 mb-3">新闻类别</h3>
        <div className="flex flex-wrap gap-2">
          {categoryOptions.map((option) => (
            <OptionButton
              key={option}
              label={option}
              active={category === option}
              onClick={() => onCategoryChange(option)}
            />
          ))}
        </div>
      </div>

      <div className="h-px bg-background-200"></div>

      <div>
        <h3 className="text-sm font-semibold text-foreground-950 mb-3">时间区间</h3>
        <div className="flex flex-wrap gap-2">
          {rangeOptions.map((option) => (
            <OptionButton
              key={option}
              label={option}
              active={range === option}
              onClick={() => onRangeChange(option)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}